import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({ standalone: false,
  selector: 'app-lang',
  templateUrl: './lang.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./lang.component.scss']
})
export class LangComponent implements OnInit {
  public flags = [
    { name:'English', image: 'assets/images/flags/gb.svg' },
    { name:'German', image: 'assets/images/flags/de.svg' },
    { name:'French', image: 'assets/images/flags/fr.svg' },
    { name:'Russian', image: 'assets/images/flags/ru.svg' },
    { name:'Turkish', image: 'assets/images/flags/tr.svg' }
  ]
  public flag:any;
  constructor() { }

  ngOnInit() {
    this.flag = this.flags[0]; 
  }

  public changeLang(flag:any){
    this.flag = flag;
  }

}
